import { useParams } from "react-router-dom";
import { SurveyType, SurveyQuestion, SurveyQuestionType } from "../../../../../../../../types/working-model";
import QuestionCardOption from "./question-card-option";
import QuestionCardTextReplies from "./question-card-text-replies";
import useSurveyResponseCount from "@/components/live-event/session/engage-section/hooks/use-survey-response-count";

import './question-card.scss';

type QuestionCardProps = {
	question: SurveyQuestion;
	type: SurveyType;
	questionNumber: number;
}
const QuestionCard = (props: QuestionCardProps) => {
	const { question, questionNumber, type } = props;
	const { language, session: sessionUuid } = useParams<{ language: string, session: string }>();
	const questionId = question.survey_question;

	const { totalResponses, questionResults } = useSurveyResponseCount({ questions: [question] });

	const isText = question.question_type === SurveyQuestionType.text;

	return (
		<div className="survey-results-question-card">
			<div className="survey-results-question-card-title">
				<h6>{questionNumber}. {question.title[language] ?? question.title.base}</h6>
			</div>

			<div className="survey-results-question-card-options">
				{!isText ? question.options.map((option, i) => {
					if (!option) return <div key={i}></div>;
					return (
						<QuestionCardOption
							key={option.survey_question_option}
							option={option}
							language={language}
							total={totalResponses}
							responses={questionResults[questionId]?.[option.survey_question_option] ?? 0}
							type={type}
						/>
					);
				}) : (
					<QuestionCardTextReplies
						questionId={question.survey_question}
						language={language}
						sessionUuid={sessionUuid}
					/>
				)}
			</div>
		</div>
	);
};

export default QuestionCard;